import FormHandler from "./FormHandler.js";
import Dropzone from "dropzone";

export default class BFDropZone extends FormHandler {

    constructor(element) {
        super(element);
        this.injectUploadListener = null;
    }

    init() {
        super.init();
        let mySelf = this;

        this.uploadUrl = this.$element.data('url');
        this.successUrl = this.$element.data('success-url');
        this.deleteUrl = this.$element.data('delete-url');
        this.thumbnailUrl = this.$element.data('thumbnail-url');
        this.uploadSource = this.$element.data('upload-source');
        this.uploadName = this.$element.data('upload-name');
        this.maxFileSize = this.$element.data('max-file-size');
        this.chunkSize = this.$element.data('chunksize');
        this.language = this.$element.data('language');
        this.allowFileTypes = this.$element.attr('data-allowfiletypes');
        this.maxFiles = this.$element.data('max-files');
        this.autoUpload = this.$element.data('auto-upload');
        this.dropZone = null;
        this.formData = this.$element.serialize();
        this.filecounter = this.$element.find('[data-type="dropzone-filecounter"]').first();
        this.$submitbutton = this.$element.find('[data-type="dropzone-submit"]').first();
        this.$helpMessage = this.$element.find('[data-type="dropzone-help-message"]').first();
        this.forceFormSubmit = false;  // um Formular auch bei Source: Messenger abschicken zu können
        this.uploadIDs = [];
        this.uploadLogIDs = "";
        this.wait4success = true;
        this.conversationID = null;
        this.$previousUploads = null;
        this.userID = null;
        this.filesCount = 0;
        this.previewsContainer = '#' + this.$element.data('preview-source');
        this.avoidPreviewLink = false;
        this.acceptedFilesString = 'image/*,video/*';
        this.acceptedFilesError = "You can not upload files of this type.";
        this.deleteRequest = true;
        this.maxFilesExceeded = "You can not upload any more files";
        this.validationName = "uploads";
        this.validationPublicUpload = "public_upload";
        this.validationAgeRestriction = "public_upload_age_restriction";
        // this.dropZoneTrigger = null; // optimierung offen: aufräumen, entscheidend wenn mehrere uploads in auf einer Unterseite existieren
        this.$enableUploadTrigger = true;
        this.presetError = null; // für Fehlermeldung bei vorhandenen Uploads

        let $previewTemplate = this.$element.find('#preview_template').first();
        let previewTemplateId = this.$element.data('preview-template');
        if (previewTemplateId !== undefined) {
            $previewTemplate = this.$element.find(previewTemplateId).first();
        }

        let conversationID = this.$element.find('[name="conversationID"]').val();
        if (conversationID !== undefined) {
            this.conversationID = conversationID;
        }

        let $previousUploads = this.$element.find('[name="uploadID[]"]');
        if ($previousUploads.length > 0) {
            this.$previousUploads = $previousUploads;
        }

        // setzt eine config für dropzone welche definiert, ob der definierte Container klickbar ist oder nicht
        let $enableUploadTrigger = this.$element.data('enable-trigger');
        if ($enableUploadTrigger != undefined) {
            this.$enableUploadTrigger = $enableUploadTrigger;
        }

        let $dropZoneErrorMessage = this.$element.data('dropzone-error-message');
        if ($dropZoneErrorMessage != undefined) {
            this.$dropZoneErrorMessage = $dropZoneErrorMessage;
        }

        const userId = this.$element.data('user-id');
        if (userId !== undefined) {
            this.userID = userId;
        }

        if (this.allowFileTypes !== undefined) {
            if (this.allowFileTypes == 'img') {
                this.acceptedFilesString = 'image/*';
            } else if (this.allowFileTypes == 'video') {
                this.acceptedFilesString = 'video/*';
            }
        }

        const deleteRequest = this.$element.data('delete-request');
        if (deleteRequest != undefined && deleteRequest == false) {
            this.deleteRequest = false;
        }

        const maxFilesExceeded = this.$element.attr('data-max-files-exceeded');
        if (maxFilesExceeded != undefined) {
            this.maxFilesExceeded = this.$element.attr('data-max-files-exceeded');
        }

        const validationName = this.$element.attr('data-validation-name');
        if (validationName != undefined) {
            this.validationName = this.$element.attr('data-validation-name');
        }
        const acceptedFilesError = this.$element.data('accepted-files-error');
        if (acceptedFilesError != undefined) {
            this.acceptedFilesError = acceptedFilesError;
        }
        const forceFormSubmit = this.$element.data('force-form-submit');
        if (forceFormSubmit != undefined && forceFormSubmit == "1") {
            this.forceFormSubmit = true;
        }
        const avoidPreviewLink = this.$element.data('avoid-preview-link');
        if (avoidPreviewLink != undefined && avoidPreviewLink == "1") {
            this.avoidPreviewLink = true;
        }
        const presetError = this.$element.data('preset-error');
        if (presetError != undefined) {
            this.presetError = presetError;
        }

        const headers = {
            'X-CSRF-TOKEN': this.csrfToken
        };

        const options = {
            headers: headers,
            url: this.uploadUrl,
            parallelUploads: 1,
            uploadMultiple: false,
            autoProcessQueue: this.autoUpload,
            addRemoveLinks: false,
            parallelChunkUploads: false,
            parallelChunkUploadsAmount: 5,
            retryChunks: true,
            chunking: true,
            forceChunking: true,
            chunkSize: this.chunkSize,
            maxFilesize: this.maxFileSize,
            paramName: 'fileupload',
            maxFiles: this.maxFiles,
            dictMaxFilesExceeded: this.maxFilesExceeded,
            thumbnailWidth: 400,
            acceptedFiles: this.acceptedFilesString,
            dictInvalidFileType: this.acceptedFilesError,
            thumbnailHeight: null,
            previewsContainer: this.previewsContainer,
            previewTemplate: $previewTemplate.html(),
            params: function (files, xhr, chunk) {

                if (chunk) {
                    let returnData = {
                        dzUuid: chunk.file.upload.uuid,
                        dzChunkIndex: chunk.index,
                        dzTotalFileSize: chunk.file.size,
                        dzCurrentChunkSize: chunk.dataBlock.data.size,
                        dzTotalChunkCount: chunk.file.upload.totalChunkCount,
                        dzChunkByteOffset: chunk.index * this.options.chunkSize,
                        dzChunkSize: this.options.chunkSize,
                        dzFilename: chunk.file.name,
                    };

                    if (chunk.file.uploadLogID !== undefined) {
                        returnData.dzUploadLogID = chunk.file.uploadLogID;
                    }
                    return returnData;
                }
            }
        }

        if (!this.$enableUploadTrigger) {
            options.clickable = false;
        } else {
            // trigger genauer benennen, wenn mehr als eine Dropzone initiiert wird
            let dropzoneTrigger = this.$element.data('dropzone-trigger');
            if (dropzoneTrigger !== undefined) {
                options.clickable = '.' + dropzoneTrigger;
            } else if (this.$element.find(".dropzone-trigger").length > 0) {
                options.clickable = '.dropzone-trigger';
            }
        }

        this.dropZone = new Dropzone(this.element, options);

        this.dropZone.uploadFiles = function (files) {
            //Hiermit wird die originale Funktion von dropzone.js soweit überschrieben, dass unsere Anforderung für parallele Chunkuploads erfüllt wird.
            // Die von Dropzone hierfür vorgesehene Funktionalität lädt ALLE Chunks auf ein Mal. Bei Videos führt dies zu Browserabstürzen

            mySelf.dropZone._transformFiles(files, (transformedFiles) => {

                if (mySelf.dropZone.options.chunking) {
                    // Chunking is not allowed to be used with `uploadMultiple` so we know
                    // that there is only __one__file.
                    let transformedFile = transformedFiles[0];
                    files[0].upload.chunked =
                        mySelf.dropZone.options.chunking &&
                        (mySelf.dropZone.options.forceChunking ||
                            transformedFile.size > mySelf.dropZone.options.chunkSize);
                    files[0].upload.totalChunkCount = Math.ceil(
                        transformedFile.size / mySelf.dropZone.options.chunkSize
                    );
                }

                if (files[0].upload.chunked) {
                    // This file should be sent in chunks!

                    // If the chunking option is set, we **know** that there can only be **one** file, since
                    // uploadMultiple is not allowed with this option.
                    let file = files[0];
                    let transformedFile = transformedFiles[0];
                    let startedChunkCount = 0;

                    file.upload.chunks = [];

                    let handleNextChunk = () => {
                        let chunkIndex = 0;

                        // Find the next item in file.upload.chunks that is not defined yet.
                        while (file.upload.chunks[chunkIndex] !== undefined) {
                            chunkIndex++;
                        }

                        // This means, that all chunks have already been started.
                        if (chunkIndex >= file.upload.totalChunkCount) return;

                        startedChunkCount++;

                        let start = chunkIndex * mySelf.dropZone.options.chunkSize;
                        let end = Math.min(
                            start + mySelf.dropZone.options.chunkSize,
                            transformedFile.size
                        );

                        let dataBlock = {
                            name: mySelf.dropZone._getParamName(0),
                            data: transformedFile.webkitSlice
                                ? transformedFile.webkitSlice(start, end)
                                : transformedFile.slice(start, end),
                            filename: file.upload.filename,
                            chunkIndex: chunkIndex,
                        };

                        file.upload.chunks[chunkIndex] = {
                            file: file,
                            index: chunkIndex,
                            dataBlock: dataBlock, // In case we want to retry.
                            status: Dropzone.UPLOADING,
                            progress: 0,
                            retries: 0, // The number of times this block has been retried.
                        };

                        mySelf.dropZone._uploadData(files, [dataBlock]);
                    };

                    file.upload.finishedChunkUpload = (chunk, response) => {

                        let allFinished = true;
                        chunk.status = Dropzone.SUCCESS;

                        // Clear the data from the chunk
                        chunk.dataBlock = null;
                        chunk.response = chunk.xhr.responseText;
                        chunk.responseHeaders = chunk.xhr.getAllResponseHeaders();
                        // Leaving this reference to xhr will cause memory leaks.
                        chunk.xhr = null;

                        for (let i = 0; i < file.upload.totalChunkCount; i++) {
                            if (file.upload.chunks[i] === undefined) {

                                if (chunk.index == 0) {

                                    let maxParallelUploads = mySelf.dropZone.options.parallelChunkUploadsAmount;
                                    if (file.upload.totalChunkCount < maxParallelUploads) {
                                        maxParallelUploads = file.upload.totalChunkCount;
                                    }
                                    if (file.upload.totalChunkCount < maxParallelUploads) {
                                        maxParallelUploads = file.upload.totalChunkCount;
                                    }

                                    for (let maxI = 0; maxI < maxParallelUploads; maxI++) {
                                        handleNextChunk();
                                    }
                                    return handleNextChunk();
                                } else {
                                    return handleNextChunk();
                                }

                            }
                            if (file.upload.chunks[i].status !== Dropzone.SUCCESS) {
                                allFinished = false;
                            }
                        }

                        if (allFinished) {
                            mySelf.dropZone.options.chunksUploaded(file, () => {
                                mySelf.dropZone._finished(files, response, null);
                            });
                        }
                    };

                    if (mySelf.dropZone.options.parallelChunkUploads) {
                        for (let i = 0; i < file.upload.totalChunkCount; i++) {
                            handleNextChunk();
                        }
                    } else {
                        handleNextChunk();
                    }
                } else {
                    let dataBlocks = [];
                    for (let i = 0; i < files.length; i++) {
                        dataBlocks[i] = {
                            name: mySelf.dropZone._getParamName(i),
                            data: transformedFiles[i],
                            filename: files[i].upload.filename,
                        };
                    }
                    mySelf.dropZone._uploadData(files, dataBlocks);
                }
            });
        }

        if (this.$previousUploads != null) {
            this.$previousUploads.each(function () {
                let mockFile = {
                    name: $(this).attr("data-file-name"),
                    size: $(this).attr("data-file-size"),
                    uploadID: $(this).attr("data-file-id"),
                    type: $(this).attr('data-media-type'),
                    isPublic: $(this).attr('data-file-is-public'),
                    ageRating: $(this).attr('data-file-age-rating'),
                    accepted: true, // in max file validierung berücksichtigen
                    error: $(this).attr('data-error')
                };
                let callback = function () { // Fehler oder bei Videos den Link zum Hochladen von Previews einblenden
                    let $previewElement = $(mockFile.previewElement);

                    if (mockFile.error) {
                        $previewElement.find('.alert').text(mockFile.error);
                        $previewElement.find('.progress-bar-success').addClass('hidden');
                        $previewElement.find('.info-filename').attr('data-bs-title', mockFile.name);
                        $previewElement.find('.info-filename').removeClass('hidden');
                        $('input[data-file-id=' + mockFile.uploadID + ']').remove();
                    } else if (mockFile.type === 'video' && mySelf.avoidPreviewLink == false) {
                        $previewElement.find('button[data-type="modalhandler"]').attr('data-modaldata', 'upload_id_hash=' + mockFile.uploadID);
                        $previewElement.find('[data-identifier="preview-modal"]').removeClass('hidden');
                    }
                };
                let crossOrigin = null;
                let resizeThumbnail = false;

                mySelf.dropZone.displayExistingFile(mockFile, $(this).attr("data-file-url"), callback, crossOrigin, resizeThumbnail);
                $(mockFile.previewElement).find('.card-img-container').attr('validation-name', 'upload_' + mockFile.uploadID);
                mySelf.dropZone.files.push(mockFile);
                mySelf.filesCount++;
            });

            // Initialisierung von Tooltips
            this.$element.trigger('tooltip:init');
            this.$element.trigger('modalhandler:init');

            this.$element.find('.progress-bar-success').css('width', '100%');
            this.$element.find('[data-type="success-mark"]').removeClass('hidden');
            this.updateFileCounter();
            this.activateSubmitButton();

            if (this.presetError != null) {
                let errorString = this.presetError;
                let options = {
                    title: errorString,
                    trigger: "manual",
                    customClass: "error"
                };
                let domElement = mySelf.$element.find('[validation-name="' + mySelf.validationName + '"]');
                let tooltip = new bootstrap.Tooltip(domElement, options);
                tooltip.show();
            }

        }

        this.dropZone.on("addedfile", function (file, done) {

            if (file.uploadID != undefined) {
                let $previewElement = $(file.previewElement);
                $previewElement.find('.progress-bar-success').css('width', '100%');
                $previewElement.find('[data-type="success-mark"]').removeClass('hidden');
                mySelf.$element.find('[data-type="display"]').removeClass('hidden');

                let $hiddenInput = $('<input type="hidden" name="uploadID[]" data-media-type="' + file.type + '">');
                $hiddenInput.val(file.uploadID);
                mySelf.$element.append($hiddenInput);
                if (mySelf.$helpMessage) {
                    mySelf.$helpMessage.addClass('hidden');
                }
                if (mySelf.uploadIDs.indexOf(file.uploadID) === -1) {
                    mySelf.uploadIDs.push(file.uploadID);
                }

                if (mySelf.dropZone.getUploadingFiles().length === 0) {
                    mySelf.activateSubmitButton();
                }
            } else {
                mySelf.deactivateSubmitButton();
                mySelf.generateVideoPreview(file, done);
            }
            mySelf.filesCount++;
            mySelf.updateFileCounter();
        });


        this.dropZone.on("removedfile", function (file) {
            mySelf.filesCount--;
            mySelf.updateFileCounter();
            if (mySelf.deleteRequest) {
                if (file.uploadID != undefined) {
                    mySelf.deleteRemovedFile(file.uploadID);
                    $('.tooltip.show').remove();
                    $('[data-toggle="tooltip"]').tooltip();
                }
            }
            let $hiddenInput = mySelf.$element.find('[name="uploadID[]"][value="' + file.uploadID + '"]');

            $hiddenInput.remove();

            mySelf.uploadIDs = mySelf.removeArrayItemOnce(mySelf.uploadIDs, file.uploadID);

            // optimierungsbedarf
            mySelf.$element.find('[data-type="display"]').addClass('hidden');
            if (mySelf.dropZone.files.length < 1) {
                mySelf.$element.find('[data-type="previewcontainer"]').removeClass('image-present');
            }

            const validationMessageHolder = mySelf.$element.find('[validation-name="' + mySelf.validationName + '"]');
            if (validationMessageHolder.length > 0) {
                const tooltip = bootstrap.Tooltip.getInstance(validationMessageHolder);
                if (tooltip != null) {
                    tooltip.dispose();
                }
            }

            // Falls durch das Entfernen des Uploads sich gleichzeitig keine Uploads mehr in der Queue befinden muss der Submit Button wieder aktiviert werden
            if (mySelf.dropZone.getUploadingFiles().length === 0) {
                mySelf.activateSubmitButton();
            }
        });

        this.dropZone.on('processing', function (file) {
        });

        this.dropZone.on('sending', function (file, xhr, formData) {
            formData.append("filesize", file.size);
        });


        this.dropZone.on("uploadprogress", function (file, progress, bytesSent) {

                if (file.xhr.status == 200) {
                    try {
                        let jsonObj = JSON.parse(file.xhr.response);
                        if (jsonObj.status !== undefined && jsonObj.status === "success") {

                            if (jsonObj.fileAvailable === "true") {
                                // Upload bereits auf dem Server vorhanden

                                // Prüft, ob im Response andere Ajax-Aktionen definiert sind
                                if (jsonObj.actions != undefined) {
                                    mySelf.handleAjaxResponse(jsonObj);
                                }

                                let previewSrc = null;
                                let $previewElement = $(file.previewElement);
                                let $previewImg = $previewElement.find('.card-img-top');
                                if ($previewImg.length == 1) {
                                    previewSrc = $previewImg.attr('src');
                                }

                                mySelf.dropZone.removeFile(file);

                                let mockFile = {
                                    name: jsonObj.fileData.filename,
                                    size: jsonObj.fileData.filesize,
                                    uploadID: jsonObj.fileData.id,
                                    type: jsonObj.type,
                                    accepted: true, // in max file validierung berücksichtigen
                                };

                                if (previewSrc == null || previewSrc.length < 2) {
                                    previewSrc = jsonObj.fileData.url;
                                }

                                mySelf.dropZone.files.push(mockFile);
                                mySelf.dropZone.displayExistingFile(mockFile, previewSrc, null, null, false);
                                $previewElement.find('.card-img-container').attr('validation-name', 'upload_' + file.uploadID);
                            } else {
                                let uploadLogID = jsonObj.uploadLogID;
                                file.uploadLogID = uploadLogID;
                            }

                        }
                        if (progress == 100) {
                            let $previewElement = $(file.previewElement);
                            $previewElement.find('[data-type="success-mark"]').removeClass('hidden');
                        }

                    } catch (e) {
                        console.error(e);
                    }
                }
            }
        );


        this.dropZone.on("success", function (file, responseText) {
            mySelf.wait4success = true;
            mySelf.dropZone.processQueue();

            // Prüft, ob im Response andere Ajax-Aktionen definiert sind
            if (responseText != undefined && responseText.actions != undefined) {
                mySelf.handleAjaxResponse(responseText);
            }

            if (file.uploadLogID != undefined) {

                mySelf.uploadLogIDs = mySelf.uploadLogIDs + "," + file.uploadLogID;

                let postData = 'source=' + mySelf.uploadSource + '&uploadLogID=' + file.uploadLogID;

                if (mySelf.conversationID != null) {
                    postData += '&conversationID=' + mySelf.conversationID;
                }

                if (mySelf.userID != null) {
                    postData += '&userID=' + mySelf.userID;
                }

                let jqxhr = $.post(mySelf.successUrl, postData, function () {
                }, 'json')
                    .done(function (jsonResponse) {
                        // Prüft, ob im Response andere Ajax-Aktionen definiert sind
                        if (jsonResponse != undefined && jsonResponse.actions != undefined) {
                            mySelf.handleAjaxResponse(jsonResponse);
                        }

                        if (jsonResponse.status !== undefined && jsonResponse.status === "success") {
                            if (jsonResponse.uploadID !== undefined) {

                                if (mySelf.uploadIDs.indexOf(jsonResponse.uploadID) === -1) {
                                    mySelf.uploadIDs.push(jsonResponse.uploadID);
                                    let $hiddenInput = $('<input type="hidden" name="uploadID[]">');
                                    $hiddenInput.val(jsonResponse.uploadID);
                                    mySelf.$element.append($hiddenInput);
                                }
                                file.uploadID = jsonResponse.uploadID;

                                if (jsonResponse.isVideo !== undefined && jsonResponse.isVideo === true && mySelf.avoidPreviewLink == false) {
                                    let $previewElement = $(file.previewElement);
                                    $previewElement.find('button[data-type="modalhandler"]').attr('data-modaldata', 'upload_id_hash=' + jsonResponse.uploadID);
                                    $previewElement.find('[data-identifier="preview-modal"]').removeClass('hidden');
                                    $previewElement.find('.card-img-container').attr('validation-name', 'upload_' + file.uploadID);

                                    // Initialisierung von Tooltips
                                    mySelf.$element.trigger('tooltip:init');
                                    mySelf.$element.trigger('modalhandler:init');
                                }

                            } else if (jsonResponse.uploadLogID !== undefined) {
                                let $hiddenInput = $('<input type="hidden" name="uploadLogID[]">');
                                $hiddenInput.val(jsonResponse.uploadLogID);
                                mySelf.$element.append($hiddenInput);
                            }
                        }
                        mySelf.wait4success = false;
                        if (mySelf.dropZone.getUploadingFiles().length === 0) {
                            // Es wurden alle Uploads verarbeitet
                            // mySelf.uploadDoneAction();
                            mySelf.activateSubmitButton();

                            // optimierungsbedarf
                            mySelf.$element.find('[data-type="display"]').removeClass('hidden');
                        }
                    });
            }
        });

        // max files validierung, tooltip initialisieren
        this.dropZone.on("maxfilesexceeded", function (file) {
            mySelf.dropZone.removeFile(file);

            const validationMessageHolder = mySelf.$element.find('[validation-name="' + mySelf.validationName + '"]');
            let tooltip = null;
            if (validationMessageHolder.length > 0) {
                tooltip = bootstrap.Tooltip.getInstance(validationMessageHolder);
            }

            if (tooltip != null) {
                tooltip.dispose();
            }

            const errors = {};
            errors[mySelf.validationName] = new Array(mySelf.maxFilesExceeded);
            mySelf.addErrors(errors);
        });

        this.dropZone.on("complete", function (file, responseText) {
            let uploadId = file.uploadID;
            let uploadLogId = file.uploadLogID;

            // Daten für Preview-Upload vorbereiten
            let modaldata = null;
            if (uploadLogId != undefined) {
                modaldata = 'uploadlog_id_hash=' + uploadLogId;
            }
            if (uploadId != undefined) {
                modaldata = 'upload_id_hash=' + uploadId;
            }

            if (modaldata) {
                let type = file.type;
                if (type != undefined && type.includes('video') && mySelf.avoidPreviewLink == false) {
                    let $previewElement = $(file.previewElement);
                    $previewElement.find('button[data-type="modalhandler"]').attr('data-modaldata', modaldata);
                    $previewElement.find('[data-identifier="preview-modal"]').removeClass('hidden');

                    // Initialisierung von Tooltips
                    mySelf.$element.trigger('tooltip:init');
                    mySelf.$element.trigger('modalhandler:init');
                }
            }
        });
        this.dropZone.on("completemultiple", function (file, responseText) {
        });
        this.dropZone.on("queuecomplete", function (file, responseText) {
            if (!mySelf.wait4success) {
                // Es wird kein Serverfeedback abgewartet
                // Derzeit ohne weitere Funktionalität
            }
        });

        this.dropZone.on("error", function (file, e) {
            const errorPreviewElement = $(file.previewElement).find('[data-dz-errormessage]');

            if (errorPreviewElement.hasClass('hidden')) {
                errorPreviewElement.removeClass('hidden');
            }

            if (typeof e === 'object') {
                errorPreviewElement.text(e.message);
            } else if (e.length !== 0) {
                errorPreviewElement.text(e);
            } else {
                errorPreviewElement.text(mySelf.$dropZoneErrorMessage);
            }
        });

        this.injectUploadListener = function (event, data) {
            let dataSource = data.source;
            let elementSource = mySelf.uploadSource;

            // hier wird sichergestellt, dass nur im richtigen UploadFormular Uploads injected werden
            if (dataSource === elementSource) {
                mySelf.deactivateSubmitButton();

                Object.values(data.uploads.injectable_uploads).forEach(
                    function (upload) {
                        let mockFile = {
                            name: upload.name,
                            size: upload.size,
                            uploadID: upload.id,
                            type: upload.type,
                            ageRating: upload.age_rating,
                            isPublic: upload.is_public,
                            accepted: true,
                        };

                        mySelf.dropZone.files.push(mockFile);

                        mySelf.dropZone.displayExistingFile(mockFile, upload.url, function () {
                            mySelf.$element.find('.progress-bar-success').css('width', '100%');
                            mySelf.$element.find('[data-type="success-mark"]').removeClass('hidden');
                            mySelf.$element.find('.card-img-container').attr('validation-name', 'upload_' + mockFile.uploadID);
                        }, true, false);
                        if (mySelf.uploadIDs.indexOf(upload.id) === -1) {
                            mySelf.uploadIDs.push(upload.id);
                        }
                    }
                )

                Object.values(data.uploads.removable_uploads).forEach(
                    function (uploadID) {
                        // Only remove if the file object is found in Dropzone's internal list of files
                        mySelf.dropZone.files.find(function (file) {
                            if (file.uploadID === uploadID) {
                                mySelf.dropZone.removeFile(file);
                                let $hiddenInput = mySelf.$element.find('[name="uploadID[]"][value="' + file.uploadID + '"]');
                                $hiddenInput.remove();
                            }
                            mySelf.uploadIDs = mySelf.removeArrayItemOnce(mySelf.uploadIDs, file.uploadID);
                        });
                    }
                )

                mySelf.activateSubmitButton();
            }
        }

        $(document).on("inject:uploads", this.injectUploadListener);

        if (this.uploadSource == "messenger" && this.forceFormSubmit == false) {
            this.$submitbutton.on('click', function (event) {
                let uploadPrice = null;
                let choiceConfirmed = false;

                let $uploadPriceSelect = mySelf.$element.find('[data-type="price_select"]');
                if ($uploadPriceSelect.length == 1) {
                    uploadPrice = $uploadPriceSelect.val();
                }

                let paidContent = uploadPrice != null && parseFloat(uploadPrice) > 0;

                let $confirmCheckbox = mySelf.$element.find('input[type="checkbox"][name="confirm_choice"]');

                if ($confirmCheckbox.length > 0) {
                    choiceConfirmed = $confirmCheckbox.prop('checked');
                }

                if (!paidContent || (paidContent && choiceConfirmed)) {
                    event.preventDefault();
                    event.stopPropagation();
                    mySelf.uploadDoneAction();
                }
            });
        }
    }

    handleAjaxResponse(responseData) {
        let mySelf = this;

        if (responseData.actions != undefined) {
            responseData.actions.forEach(function (action) {
                switch (action.actionType) {
                    case "uploadSelectedFiles":
                        mySelf.uploadDoneAction();
                        break;
                }
            });
            super.handleAjaxResponse(responseData);
        }
    }

    removeArrayItemOnce(arr, value) {
        var index = arr.indexOf(value);
        if (index > -1) {
            arr.splice(index, 1);
        }
        return arr;
    }

    generateVideoPreview(file, done) {
        var video = document.createElement('video');
        let mySelf = this;

        if (file.type.match(/video/)) {
            if (video.canPlayType(file.type) !== "no") {
                var fileURL = URL.createObjectURL(file);
                video.src = fileURL;
                video.addEventListener('loadeddata', function () {
                    var canvas = document.createElement('canvas');
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
                    var dataURI = canvas.toDataURL('image/png');
                    let $previewImage = $(file.previewElement).find('.card-img-top');
                    $previewImage.attr('src', dataURI);

                });
            } else {
                console.error("video not previewable");
                return;
            }
        }
    }

    activateSubmitButton() {
        this.$submitbutton.removeAttr('disabled', false);
    }

    deactivateSubmitButton() {
        this.$submitbutton.prop('disabled', true);
    }

    uploadDoneAction() {
        if (this.uploadSource == "messenger") {
            let conversationID = this.$element.find('[name="conversationID"]').val();

            if (conversationID != undefined) {
                let $textArea = this.$element.find('textarea');
                let uploadMessage = $textArea.val();

                let uploadPrice = null;
                let uploadCurrency = null;

                let $uploadPriceSelect = this.$element.find('[data-type="price_select"]');
                if ($uploadPriceSelect.length == 1) {
                    uploadPrice = $uploadPriceSelect.val();
                }

                let tmpUploadCurrency = this.$element.find('[name="currencyID"]').val();
                if (tmpUploadCurrency != undefined) {
                    uploadCurrency = tmpUploadCurrency;
                }

                if (uploadPrice != null && parseFloat(uploadPrice) > 0) {
                    // Kostenpflichtige Uploads benötigen eine Beschreibung
                    if (uploadMessage.length < 20) {
                        let errorString = $textArea.attr('data-error-txt');
                        let options = {
                            title: errorString,
                            trigger: "manual",
                            customClass: "error"
                        };
                        let domElement = $textArea.get(0);
                        let tooltip = new bootstrap.Tooltip(domElement, options);
                        tooltip.show();

                        setTimeout(function () {
                            tooltip.hide();
                        }, 2000);
                        return false;
                    }
                }

                if (this.uploadIDs.length === 0) {
                    let errorString = this.filecounter.attr('data-error-txt');
                    let options = {
                        title: errorString,
                        trigger: "manual",
                        customClass: "error"
                    };
                    let domElement = this.filecounter.get(0);
                    let tooltip = new bootstrap.Tooltip(domElement, options);
                    tooltip.show();

                    setTimeout(function () {
                        tooltip.hide();
                    }, 2000);
                    return false;
                }

                $(document).trigger('Messenger:newMessengerImage', {
                    conversationID: conversationID,
                    uploadMessage: uploadMessage,
                    uploadPrice: uploadPrice,
                    uploadCurrency: uploadCurrency,
                    imageID: this.uploadIDs,
                });
                $(document).trigger("modals:hide");
            }
        }
    }

    deleteRemovedFile(uploadID) {
        let postData = {
            uploadID: uploadID,
            source: this.uploadSource
        };
        let jqxhr = $.post(this.deleteUrl, postData, function () {
        }, 'json');
    }

    updateFileCounter() {
        if (this.filecounter != null) {
            this.filecounter.find('.current').html(this.filesCount);
            this.filecounter.find('.total').html(this.maxFiles);
        }
        if (this.filesCount == 0) {
            this.deactivateSubmitButton();
        }
    }

    destroyListener() {
        if (this.dropZone != null) {
            this.dropZone.disable();
            delete this.dropZone;
        }
    }
}